module.exports = __webpack_public_path__ + "img/avabot-header.866f8efe.jpg";